module.exports = __webpack_public_path__ + "img/manual-grn-00-print-example.e0b8e4f7.png";